export default "__VITE_ASSET__de19166c__"